export const ParseFile = 0;
export const MapScript = 1;